/**
 * 模块 - 驾驶舱/绩效复盘 - 中文
 */
export default {
  // 直接作为根级属性，方便使用 $t('cockpitManage.xxx')
  cockpitManage: {
    completion1: '完成度',
    completed2: '已完成',
    uncompleted3: '未完成',
    completion4: '完成度',
    completed5: '已完成',
    uncompleted6: '未完成',
    indicator7: '指标',
    orderCount8: '订单数',
    visitCount9: '到访数',
    commitmentCount10: '诺访数',
    wechatCount11: '加微数',
    callCount12: '电话数',
    quantity13: '数量',
    channelProportion14: '渠道占比',
    channelProportion15: '渠道占比',
    channelConversion16: '渠道转化率',
    startDate17: '开始日期',
    endDate18: '结束日期',
    dashboard49: '仪表盘',
    currentTimeProgress50: '当前时间进度',
    performanceCompletion51: '业绩完成情况',
    learningRevenue52: '学习机收入',
    target53: '目标',
    supervisorRevenue54: '督学收入',
    target55: '目标',
    channelConversionOverview56: '渠道转化概览',
    processMetrics57: '过程指标统计',
    funnelMetrics58: '漏斗指标统计',
    clueCall59: '线索电话',
    callWechat60: '电话加微',
    wechatCommitment61: '加微诺访',
    commitmentVisit62: '诺访到访',
    visitConversion63: '到访转化',
    salesPerformanceProgress64: '销售业绩完成进度',
    redBelowTimeProgress65: '红色为完成进度低于时间进度',
    salesFollowUpStats66: '销售累计跟进统计',
    remindSalesDaily67: '请提醒销售人员每日前往钉钉工作台业绩管理进行任务上报',
    statsDate68: '统计日期',
    selectMonth69: '选择月',
    selectDatePlaceholder: '选择日期',

    // 基础参数设置
    targetParamsSetting: '目标参数设置',
    avgPriceLabel: '平均售价',
    conversionRate: '转化率',
    visitRate: '到访率',
    promiseVisitRate: '诺访率',
    addWechatRate: '加微率',
    supervisorNewSignRate: '督学新签率',
    supervisorAvgPrice: '督学均价',
    enterAvgPrice: '请输入平均售价',
    enterConversionRate: '请输入转化率',
    enterVisitRate: '请输入到访率',
    enterPromiseVisitRate: '请输入诺访率',
    enterAddWechatRate: '请输入加微率',
    enterSupervisorNewSignRate: '请输入督学新签率',
    enterSupervisorAvgPrice: '请输入督学均价',
    edit: '编辑',
    save: '保存',
    reset: '重置',
    yuan: '元',

    // 上报提醒设置
    reportReminderSettings: '上报提醒设置',
    reminderTime: '提醒时间',
    everyday: '每天',
    reminderDescription: '向需要完成任务上报的员工进行钉钉短信的待办提醒',
    timesUnit: '次',

    // 提示信息
    tip1: '系统默认的平均售价由经销商上月售卖全部学习机的零售价求平均',
    tip2: '若上月未售卖学习机则取自全国平均售价',
    tip3: '系统默认的转化率、到访率、诺访率、加微率、督学新签率、督学均价采用行业标准推荐数值',
    tip4: '所有参数均可通过编辑进行个性化修改，修改保存后将对未开始的目标生效',
    tip5: '点击重置可将对应参数数值将恢复使用系统默认值，重置成功后将对未开始的目标生效',

    // CockpitTarget - 目标管理/目标设定
    targetManagement: '目标管理',
    noTargetThisMonthTip: '您本月还没制定过目标哦，赶快添加吧',
    newTarget: '新目标',
    addTarget: '添加目标',
    monthlyTarget: '本月目标',
    selfBuilt: '自建',
    superior: '上级',
    targetRevenue: '目标收入',
    currentRevenue: '当前收入',
    actualRevenue: '实际收入',
    completion: '完成度',
    timeProgress: '时间进度',
    notStarted: '未开始',
    remainingDays: '剩余{days}天',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    operationReminder: '操作提醒',
    deleteTargetConfirmTip: '删除目标后将会导致当前已提交的业绩数据清零，同时该目标包含的销售目标将会一并清零，请谨慎操作！',

    exit: '退出',
    targetDetail: '目标详情',
    targetSetting: '目标设定',
    targetCycle: '目标周期',
    selectMonthPlaceholder: '选择月',
    superiorAddedTargetTip: '您的上级已给你添加了该月的目标，可根据以下目标去进行分配',
    learningMachinePart: '学习机部分',
    supervisorPart: '督学部分',
    estimatedRevenue: '预计收入',
    estimateBasedOnOfficialRetailPrice: '根据官方参考零价预估',
    model: '机型',
    targetUnits: '目标台数',
    totalTargetRevenue: '总目标收入',
    promoteTarget: '我要提升目标',
    myTarget: '我的目标',
    supervisorIncomeDefaultTip: '督学部分收入默认值为学习机台数',
    supervisorNewSignRateTip1: '督学新签率、督学服务单价您可',
    supervisorNewSignRateTip2: '在驾驶舱基础设置中修改相关参数，',
    supervisorNewSignRateTip3: '或直接填写您预期的目标收入',
    totalRevenue: '总收入',
    nextStepAssignTarget: '下一步：分配目标',
    smartAssignedTip: '已根据你的目标/上级目标设定为所有员工进行了智能分配，可对学习机/督学目标进行调整',
    targetSource: '目标来源',
    selfBuiltTarget: '自建目标',
    superiorAgent: '上级代理',
    addStaff: '添加员工',
    ratioMode: '比例模式填写',
    revenueMode: '收入模式填写',
    restoreDefaultPlan: '恢复至默认方案',
    learningRevenueRatio: '学习机收入比例',
    learningRevenue: '学习机收入',
    supervisorRevenueRatio: '督学收入比例',
    supervisorRevenue: '督学收入',
    totalTarget: '总目标',
    targetBreakdown: '目标拆解',
    total: '总计',
    backToTargetSetting: '返回到目标设定',
    confirmModify: '确认修改',
    complete: '完成',
    select: '选择',
    name: '姓名',
    staffRole: '员工角色',
    tipTitle: '提示',
    switchModeConfirmTip: '确定切换填写模式？',
    switchModeImpactTip: '所有员工收入比例将重新调整，请谨慎操作',
    restoreDefaultTip1: '当前员工有增删，学习机收入比例及督学收入比例将恢复至默认方案',
    restoreDefaultTip2: '所有员工比例将重新调整，请谨慎操作',
    salesName: '销售姓名',
    assignRatio: '分配比例',
    revenueTarget: '收入目标',
    processTarget: '过程目标',
    processTargetTip: '过程目标由默认设置比例自动计算，如不合预期，您可在驾驶舱基础设置中修改相关参数',
    iKnow: '我知道了',
    submitTargetConfirmPrefix: '提交目标后，当前目标将下发至您指定的员工，并将于',
    submitTargetConfirmSuffix: '正式生效，请确认是否继续提交？',
    deleteStaffImpactTip: '删除人员后会导致人员业绩目标比例/收入清零，同时该目标包含的销售目标将会一并清零，请谨慎操作！',
    pleaseEnterLearningTarget: '请输入学习机部分目标',
    pleaseEnterSupervisorTarget: '请输入督学部分目标',
    previousMonthTargetLabel: '上月目标：',
    actualCompletedLabel: '实际完成：',
    staffAddedCount: '已添加 {count} 个员工',
    actualRevenueLabel: '实际收入：',
    targetRevenueLabel: '目标收入：',
    currentRevenueLabel: '当前收入：',
    effectiveDate: '{year}年{month}月1日',
    learningMachinePartPrefix: '学习机部分：',
    supervisorPartPrefix: '督学部分：'
    ,
    estimatedTargetPrefix: '预计目标',
    targetPrefix: '目标',
    learningMachinePartWithDash: '学习机部分-',
    supervisorPartWithColon: '督学部分：'
    ,
    myLearningRevenueNotBelow: '我的目标学习机部分收入不能低于{amount}',
    mySupervisorRevenueNotBelow: '我的目标督学部分收入不能低于{amount}'
  },
  cockpit: {
    // ... existing keys ...
    resultOutcome: '结果指标',
    processOutcome: '过程指标',
    workSpotCheck: '工作抽查',
    statsDate: '统计日期',
    staffName: '员工姓名',
    reportDate: '上报日期',
    reportDatePlaceholder: '上报日期',
    salesPerson: '销售人员',
    date: '日期',
    totalAmount: '总收入',
    totalTarget: '总目标',
    totalTargetCompletion: '总目标完成度',
    learningMachineAmount: '学习机收入',
    learningMachineTarget: '学习机收入目标',
    learningMachineCompletion: '学习机目标完成度',
    supervisorAmount: '督学收入',
    supervisorTarget: '督学收入目标',
    supervisorCompletion: '督学目标完成度',
    supervisorNewSign: '督学新签收入',
    supervisorRenew: '督学续费收入',
    clueNum: '线索数量',
    clueNumShort: '线索数',
    callNum: '电话数',
    callTarget: '电话目标',
    callRate: '电话率',
    callRecord: '电话记录',
    wechatNum: '加微数',
    wechatTarget: '加微目标',
    wechatRate: '加微率',
    wechatRecord: '加微记录',
    commitmentNum: '诺访数',
    commitmentTarget: '诺访目标',
    commitmentRate: '诺访率',
    commitmentRecord: '诺访记录',
    instoreNum: '到访数',
    instoreTarget: '到访目标',
    instoreRate: '到访率',
    instoreRecord: '到访记录',
    orderNum: '成单数',
    orderTarget: '成单目标',
    orderRecord: '成单记录',
    conversionRate: '转化率',
    orderDetail: '成单明细',
    orderType: '成单类型',
    view: '查看',
    selectMonth: '选择月',
    learningMachineSupervisor: '学习机-督学',
    learningMachine: '学习机',
    supervisor: '督学',
    snCode: 'SN码',
    learningMachineModel: '学习机型号',
    adaptiveAccount: '智适应账号',
    orderAmount: '成单金额',
    orderSplit: '订单分摊',
    splitDetail: '分摊详情',
    credential: '凭证',
    noCredential: '暂无凭证',
    close: '关 闭',
    splitDetailTitle: '分摊详情',
    person: '人员',
    splitRate: '分摊比例',
    clueName: '线索姓名',
    cluePhone: '线索手机号',
    clueSource: '线索来源',
    followUploadTime: '跟进记录上传时间',
    credentialDetail: '凭证详情',
    descCredential: '描述/凭证',
    collabSplit: '协作分摊',
    record: '记录',
    dailySummary: '每日小结',
    processOutcomeExport: '过程指标数据导出',
    resultOutcomeExport: '结果指标数据导出',
    todayWorkContent: '今日工作内容：',
    deleteSuccess: '删除成功'
  }
}
